module.exports = __webpack_public_path__ + "img/exchange_succes.7fcc8e7b.png";